import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Modal, Typography, Button } from '@mui/material';
import { getDashboard } from 'api';
import FloatingBookingSelector from 'components/organisms/floatingBookingSelector/view';
import UserMainInfo from 'components/organisms/userMainInfo/view';
import VenueSlider from 'components/organisms/venueSlider/view';
import BookingDetail from 'components/pages/booking/bookingDetail/view';
import { Container, ModalContent } from './styled';
import { useProfile } from 'context';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';


const ONBOARDING_DISMISSED_KEY = 'hive_onboarding_dismissed';

const DashboardHome = () => {
  const { profile } = useProfile();
  
  // Check if onboarding was previously dismissed
  const wasOnboardingDismissed = () => {
    try {
      const dismissed = localStorage.getItem(ONBOARDING_DISMISSED_KEY);
      return dismissed === 'true';
    } catch {
      return false;
    }
  };
  
  const [showOnboarding, setShowOnboarding] = useState(
    profile?.onboarding < 50 && !wasOnboardingDismissed()
  );
  const [dashboardInfo, setDashboardInfo] = useState({
    bookings: [],
    events: [],
    communities: [],
  });
  const [venues, setVenues] = useState([]);
  const navigate = useNavigate();
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [view, setView] = useState('full');
  const [loading, setLoading] = useState(true);
  const [startDate] = useState(dayjs().startOf('week'));
  const endDate = startDate.add(4, 'day');
  
  // Handle dismissing onboarding modal - save to localStorage
  const handleDismissOnboarding = () => {
    try {
      localStorage.setItem(ONBOARDING_DISMISSED_KEY, 'true');
    } catch (e) {
      console.warn('Could not save onboarding preference to localStorage');
    }
    setShowOnboarding(false);
  };

  useEffect(() => {
    getDashboardInfo(true);
  }, []);

  const getDashboardInfo = () => {
    setLoading(true);

    const params = {
      start: startDate.format('YYYY-MM-DD'),
      end: endDate.format('YYYY-MM-DD'),
      page_size: 5,
      page_number: 1,
    };
    getDashboard(params)
      .then(r => {
        setDashboardInfo({
          bookings: r.upcoming_info?.bookings || [],
          events: r.upcoming_info?.events || [],
          communities: r.communities || [],
        });
        setVenues(r.venues || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleBookingAction = (slug, action, updatedBooking = null) => {
    switch (action) {
      case 'accept':
        // Handle accept logic
        break;
      case 'reject':
        // Handle reject logic
        break;
      case 'update':
        // Update the booking in state
        if (updatedBooking) {
          setDashboardInfo(prevDashboardInfo => ({
            ...prevDashboardInfo,
            bookings: prevDashboardInfo.bookings.map(b => 
              b.slug === slug ? updatedBooking : b
            )
            
          }));
          setSelectedBooking(updatedBooking);
        }
        break;
      // Other cases...
    }
  };


  const navigateBooking = (booking, view) => {
    if (!view) {
      view = 'full';
    }
    setView(view);
    setSelectedBooking(booking);
    setOpenDetails(true);
  };

  const navigateVenue = (slug) => {
    navigate(`/venue/${slug}`);
  };

  const navigateProfile = () => {
    navigate(`/profile`);
  };

  
  return (
    <Container>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12} md={12} sx={{ paddingTop: 5 }}>
          <UserMainInfo
            profile={profile}
            bookings={dashboardInfo.bookings}
            navigateBooking={(booking, view) => navigateBooking(booking, view)}
            loading={loading}
            onBookingUpdated={(updatedBookings) => setDashboardInfo({
              ...dashboardInfo,
              bookings: updatedBookings
            })}
          />
          {/* <BookingListHome
            navigateBooking={(booking, view) => navigateBooking(booking, view)}
            bookings={dashboardInfo.bookings}
          /> */}
        </Grid>
      </Grid>
      { venues?.length > 0 &&  <Grid container spacing={{ xs: 2, md: 3 }} sx={{ marginBottom: 5 }}>
        <Grid item xs={12} md={12} sx={{ paddingTop: 5 }}>
          <VenueSlider navigateVenue={(item) => navigateVenue(item)} venues={venues} showMore={true} />
        </Grid>
      </Grid>
      }



      {profile?.imAdmin && <FloatingBookingSelector />}
      <Modal open={showOnboarding} onClose={handleDismissOnboarding}>
        <ModalContent>
          <Typography variant="h5" align="center" gutterBottom>
            Complete Your Profile
          </Typography>
          <Typography variant="body1" align="center" sx={{ mt: 2 }}>
            Hey, it’s great having you here! Can you take a few minutes to add more details to your profile?
            This will help communities get to know you better and make the most of your experience.
          </Typography>
          <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
            <Grid item>
              <Button onClick={() => navigateProfile()} variant="contained" color="secondary">
                Complete Profile
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={handleDismissOnboarding} variant="outlined" color="warning">
                Maybe Later
              </Button>
            </Grid>
          </Grid>
        </ModalContent>
      </Modal>
      <Modal
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ModalContent>
          <BookingDetail booking={selectedBooking} view={view} handleBookingAction={handleBookingAction} />

        </ModalContent>
      </Modal>

    </Container>
  );
};

export default DashboardHome;
